import { IonButton, IonCard, IonCardContent } from "@ionic/react";
import { file2Base64 } from "lib";
import { useEffect, useState } from "react";
import { LuXCircle } from "react-icons/lu";

interface IProps {
  files: File[];
  prompt: string | null | undefined;
  clearAttachment?: (index?: number) => void;
}

function Preview({ file }: { file: File }) {
  const [url, setURL] = useState<string>();

  useEffect(() => {
    let objectUrl: string | undefined;

    if (!file) return;

    if (file.type.startsWith("image/")) {
      file2Base64(file)
        .then(setURL)
        .catch(() => {});
    } else {
      objectUrl = URL.createObjectURL(file);
      setURL(objectUrl);
    }
    return () => {
      if (objectUrl) {
        URL.revokeObjectURL(objectUrl);
      }
    };
  }, [file]);

  if (!url) return null;
  if (file.type === "application/pdf") {
    return (
      <object data={url} type="application/pdf" style={{ width: "100%", height: 220 }}>
        {file.name}
      </object>
    );
  }
  return <img src={url} style={{ maxWidth: "100%" }} />;
}

export default function PromptCard({ files, prompt, clearAttachment }: IProps) {
  return (
    <IonCard style={{ width: "calc(100% - 24px)", padding: 8, marginBottom: 6 }}>
      {prompt ? (
        <IonCardContent style={{ whiteSpace: "pre-wrap", userSelect: "text" }}>
          {prompt}
        </IonCardContent>
      ) : clearAttachment !== undefined ? (
        <IonButton fill="clear" onClick={() => clearAttachment()}>
          <LuXCircle size={24} />
        </IonButton>
      ) : undefined}
      {files.map((f, i) => (
        <div
          key={f.name}
          style={{
            marginBottom: 12,
            border: "1px solid #ddd",
            borderRadius: 7,
            padding: 6,
            background: "#fafbfc",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              marginBottom: 2,
            }}
          >
            <span style={{ fontSize: 13, color: "#444", wordBreak: "break-all" }}>{f.name}</span>
            {clearAttachment && (
              <IonButton fill="clear" onClick={() => clearAttachment(i)}>
                <LuXCircle size={20} />
              </IonButton>
            )}
          </div>
          <Preview file={f} />
        </div>
      ))}
    </IonCard>
  );
}
